<template>
  <div class="centrechart" v-loading="loadingshow" element-loading-background="rgba(0, 0, 0, 0)">
    <div class="centercontent">
      <div id="charts" class="echarts" ref="gisChart1" v-resize="resize"></div>
    </div>
  </div>
</template>

<script>
import * as echarts from 'echarts';
import './china.js'; // 引入中国地图数据
import City from './City.js';

export default {
  data() {
    return {
      mapChart: null,
      option: null,
      provinces: [],
      cityname: '济源',
      loadingshow: false,
    };
  },
  mounted() {
    this.getData();
  },
  beforeDestroy() {
    if (this.timer) {
      clearTimeout(this.timer); // 在Vue实例销毁前，清除我们的定时器
    }
  },
  methods: {
    async getData() {
      clearTimeout(this.timer);
      let datasource =
        this.$store.state.menutree.filter(v => v.code == this.$route.name)[0].datasource || 'index';
      let currentDate = new Date();
      let currentYear = currentDate.getFullYear();
      let params = {
        start_date: currentYear + '-01-01',
        end_date: currentYear + '-12-31',
        type: 'province',
        destination_id: this.$store.state.userInfo.data.destination_id,
      };

      let result = await this.$Touris.getTouristPlace(datasource, params);

      let City = '';
      switch (this.$store.state.userInfo.data.destination_id) {
        case 72:
          City = '扎达';
          break;
        case 75:
          City = '济源';
          break;
        default:
          City = '';
      }
      this.cityname = City;
      this.provinces = [];
      result.data
        .sort((a, b) => a.sumNums - b.sumNums)
        .slice(0, 30)
        .forEach(v => {
          v.name = v.name.replace('省', '');
          console.log(v.name, 'dddddddddd');
          this.provinces.push({ name: v.name, value: v.sumNums });
        });

      this.drawCharts();
      this.loadingshow = false;
      this.timer = setTimeout(() => {
        this.getData();
      }, 180000);
    },
    drawCharts() {
      // 地图的坐标信息
      var geoCoordMap = City;
      var cname = this.cityname;
      // 数据信息
      var BJData = this.provinces
        .filter(item => item.value > 0)
        .map(item => {
          return [
            {
              name: cname,
            },
            {
              name: item?.name,
              value: item?.value,
            },
          ];
        });

      // 计算数据的最大值、最小值，用于动态分级
      var values = this.provinces.filter(item => item.value > 0).map(item => item.value);
      var maxValue = Math.max(...values);
      var minValue = Math.min(...values);
      var avgValue = values.reduce((sum, val) => sum + val, 0) / values.length;

      // 动态计算分级阈值
      var threshold1 = minValue + (avgValue - minValue) * 0.3; // 低档
      var threshold2 = avgValue; // 中档
      var threshold3 = avgValue + (maxValue - avgValue) * 0.5; // 高档

      // 颜色分级函数
      var getColorByValue = function (value) {
        if (value <= threshold1) {
          return '#ffe566'; // 黄色 - 最低档
        } else if (value <= threshold2) {
          return '#74ebd5'; // 青色 - 中低档
        } else if (value <= threshold3) {
          return '#5bc0eb'; // 蓝色 - 中高档
        } else {
          return '#f26419'; // 橙红色 - 最高档
        }
      };

      var planePath =
        'path://M1705.06,1318.313v-89.254l-319.9-221.799l0.073-208.063c0.521-84.662-26.629-121.796-63.961-121.491c-37.332-0.305-64.482,36.829-63.961,121.491l0.073,208.063l-319.9,221.799v89.254l330.343-157.288l12.238,241.308l-134.449,92.931l0.531,42.034l175.125-42.917l175.125,42.917l0.531-42.034l-134.449-92.931l12.238-241.308L1705.06,1318.313z';
      var convertData = function (data) {
        // data BJData
        var res = [];
        for (var i = 0; i < data.length; i++) {
          // BJData
          var dataItem = data[i];
          var fromCoord = geoCoordMap[dataItem[0].name]; // 北京
          var toCoord = geoCoordMap[dataItem[1].name ? dataItem[1].name : dataItem[0].name]; // 成都
          if (fromCoord && toCoord) {
            res.push([
              {
                coord: toCoord,
                value: dataItem[1].value ? dataItem[1].value : 0,
              },
              {
                coord: fromCoord,
              },
            ]);
          }
        }
        return res;
      };
      var series = [];
      [[cname, BJData]].forEach(function (item) {
        series.push(
          {
            // 设置飞机后的烟雾
            type: 'lines',
            zlevel: 1,
            effect: {
              show: true,
              period: 6,
              trailLength: 0.7,
              color: 'white', // 设置烟雾颜色
              symbolSize: 3, // 设置烟雾大小
              symbol: planePath, // 采用飞机还是抛物线  我这里采用的是飞机  不需要飞机用第一个 planePath
            },
            // 线宽
            lineStyle: {
              normal: {
                color: '#fff',
                width: 0,
                curveness: 0.2,
              },
            },
            data: convertData(item[1]), // 这里应用的是上面convertData函数返回的坐标系坐标
          },
          {
            name: '航线', // 设置飞机图中的文字
            type: 'lines',
            zlevel: 2,
            effect: {
              show: true,
              period: 6,
              trailLength: 0,
              symbol: planePath,
              symbolSize: 15,
            },
            lineStyle: {
              normal: {
                // 看需求完成根据数据的大小 改变飞机的颜色
                color: function (params) {
                  if (params.value > 0 && params.value <= 1) {
                    return '#ffe566';
                  } else if (params.value === 2) {
                    return '#74ebd5';
                  } else if (params.value > 2 && params.value < 4) {
                    return '#5bc0eb';
                  } else {
                    return '#f26419';
                  }
                },
                width: 1,
                opacity: 0.4,
                curveness: 0.2,
              },
            },
            data: convertData(item[1]), // 这里应用的是上面convertData函数返回的坐标系坐标
          },
          {
            // 设置圆圈属性的
            name: item[0], // 名字 参考遍历的数组 ‘北京’
            type: 'effectScatter',
            coordinateSystem: 'geo',
            // 鼠标移入显示的东西
            tooltip: {
              showDelay: 0,
              // 这里自己配置的移入框 根据需求完成配置即可
              formatter: function (params) {
                return `
${params.name}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<br/>游玩人数:
        <span">${params.value[2]}人</span>`;
              },

              axisPointer: {
                show: true,

                type: 'cross',

                lineStyle: {
                  type: 'dashed',

                  width: 1,
                },
              },
            },
            zlevel: 2,
            rippleEffect: {
              brushType: 'stroke',
            },
            label: {
              normal: {
                show: true,
                position: 'right',
                formatter: '{b}',
                // 文字颜色
                color: 'rgb(249, 249, 249)',
              },
            },
            // 设置圆圈大小
            symbolSize: function (val) {
              // val的值是data的值
              return 10;
            },
            itemStyle: {
              normal: {
                // 根据数据的大小  展示不同的颜色
                color: function (params) {
                  if (params.value[2] > 0 && params.value[2] <= 1) {
                    return '#ffe566';
                  } else if (params.value[2] === 2) {
                    return '#74ebd5';
                  } else if (params.value[2] > 2 && params.value[2] < 4) {
                    return '#5bc0eb';
                  } else {
                    return '#f26419';
                  }
                },
              },
            },
            // data这里就是需要坐标系还有总体移入的名称
            data: item[1].map(function (dataItem) {
              const name = dataItem[1].name;
              const value = dataItem[1].value;
              if (geoCoordMap[name] !== undefined) {
                return {
                  name: name,
                  value: geoCoordMap[name].concat([value]),
                };
              } else {
                return {
                  name: name,
                  value: [], // 或者返回一个默认值，比如空数组
                };
              }
            }),
          },
        );
      });

      this.mapChart = this.$echarts.init(this.$refs.gisChart1);
      this.mapChart.clear();

      this.option = {
        // 设置为半透明
        backgroundColor: 'transparent',
        title: {
          left: 'left',
          textStyle: {
            color: '#fff',
          },
        },
        tooltip: {
          trigger: 'item',
        },
        // 设置地图默认大小
        geo: {
          zoom: 1.2,
          map: 'china',
          label: {
            normal: {
              show: false,
              color: '#fff',
            },
            emphasis: {
              show: true,
              color: '#fff',
            },
          },
          roam: true,
          regions: [
            // 隐藏右下框
            {
              name: '南海诸岛',
              itemStyle: {
                // 隐藏地图
                normal: {
                  opacity: 0, // 为 0 时不绘制该图形
                },
              },
              label: {
                show: false, // 隐藏文字
              },
            },
          ],
          itemStyle: {
            // 设置区块颜色
            areaColor: 'rgba(14,108,155, 0)',
            borderWidth: 2,
            borderColor: 'rgba(0,198,225,0.6)', // 地图边框
            shadowColor: 'rgba(0,198,225,0)',
            shadowBlur: 5,
            shadowOffsetX: 5,
            shadowOffsetY: 6,
            emphasis: {
              // 设置鼠标悬停时候的样式
              areaColor: '#15b6e4',
            },
          },
        },

        visualMap: {
          // 颜色的设置  dataRange
          // show: false,
          textStyle: { color: '#fff' },
          x: '80%',
          y: '76%',
          splitList: [
            {
              start: threshold3,
              end: maxValue,
              color: '#f26419',
              label: `高流量`,
            },
            {
              start: threshold2,
              end: threshold3,
              color: '#5bc0eb',
              label: `中高流量`,
            },
            {
              start: threshold1,
              end: threshold2,
              color: '#74ebd5',
              label: `中低流量`,
            },
            {
              start: minValue,
              end: threshold1,
              color: '#ffe566',
              label: `低流量`,
            },
            // { start: 30 },
            // { start: 20, end: 30 },
            // { start: 10, end: 20 },
            // { start: 0, end: 10 }
          ],
          color: ['#f26419', '#5bc0eb', '#74ebd5', '#ffe566'],
        },
        series: series,
      };
      // this.$echarts.init(document.getElementById('charts')).setOption(option)

      let _this = this;
      window.addEventListener('resize', () => {
        _this.mapChart.resize();
      });
      this.mapChart.setOption(this.option);
    },
    resize() {
      if (window.innerWidth < 1400) {
        this.offset = 30;
      } else {
        this.offset = 40;
      }
      this.mapChart.resize();
    },
  },
};
</script>

<style lang="scss" scoped>
.opemap {
  width: 50vw;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  pointer-events: none;
}
.centrechart {
  position: fixed;
  left: 22.9%;
  top: 22.1%;
  z-index: 11;
  .centercontent {
    width: 50.22vw;
    height: 60.66vh;
    position: relative;
  }
}
.echarts {
  width: 100%;
  height: 100%;
}
@media screen and (max-width: 1441px) {
  .centrechart .centercontent {
    /* max-height: 122.56px; */
  }
}
</style>
